import { makeStyles } from '@material-ui/core/styles';
import colors from '../../theme/colors';

export default makeStyles((theme) => ({
  dialogModal: {
    alignItems    : 'center',
    borderRadius  : '4px 0',
    display       : 'flex',
    flexDirection : 'column',
    paddingBottom : '40px',
    paddingLeft   : '32px',
    paddingRight  : '32px',
    paddingTop    : '64px',
    width         : '100%'
  },
  dialogTitle: {
    marginBottom : theme.spacing(1),
    marginTop    : theme.spacing(1),
    textAlign    : 'center'
  },
  title: {
    color      : colors.DARK_GRAY,
    fontSize   : '14px',
    lineHeight : '20px',
  },
  dialogContent: {
    textAlign  : 'center'
  },
  message: {
    color      : colors.DARK_GRAY,
    fontWeight : '700',
    lineHeight : '24px'
  },
  dialogActions: {
    alignItems     : 'center',
    backgroundColor: colors.LIGHT_GRAY,
    display        : 'flex',
    gap            : '8px',
    justifyContent : 'space-around',
    paddingBottom  : '26px',
    paddingLeft    : '34px',
    paddingRight   : '34px',
    paddingTop     : '26px',
    width          : '100%',
  },
  dialogButton: {
    borderRadius : '8px',
    display      : 'flex',
    float        : 'left',
    height       : '40px',
    lineHeight   : '16px',
    padding      : '10px 20px',
    width        : 'auto'
  },
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      width    : '430px',
      maxWidth : '100%'
    }
  },
  icon: {
    height : '36px !important',
    width  : '36px !important'
  }
}));